import { Cookie } from "./core/Cookie";
import { Elements } from "./core/Elements";
import { yesNo } from "./core/YesNo";
import { entersite } from "./main";

export async function logout() : Promise<void> {

    if( await yesNo('Logga ut', 'Är du säker?') ) {
        Cookie.username = '';
        Elements.leftSidebar.innerHTML = '';
        entersite(Cookie.pagename);
    }

}
